import React from "react";
import styles from "./ViewMoreModal.module.css";
import {Button, ButtonState} from "../../../button/Button";
import {CloseImageButton} from "../../../closeImageButton/CloseImageButton";

interface ViewMoreModalProps {
    value: any;
    title?: string;
    handleClose: (value?: any) => any;
}

export const ViewMoreModal: React.FC<ViewMoreModalProps> = ({
                                                                value,
                                                                title = "Knowledgebase",
                                                                handleClose
                                                            }) => {
    return <div className={styles.wrapper}>
        <div className={styles.textWrapper}>
            <div className={styles.titleWrapper}>
                <span className={styles.title}>{title}</span>
                <CloseImageButton onClose={handleClose}/>
            </div>
            <span className={styles.value}>{value}</span>
        </div>
        <div className={styles.buttonsWrapper}>
            <Button
                title={"Okay"}
                state={ButtonState.PRIMARY}
                handleClick={handleClose}
            />
        </div>
    </div>
};
